import React from 'react';
import {css} from "@emotion/react";
import {useAuth} from "../Auth";
import {Button} from "../Button";
import {TriGrid} from "../TriGrid";
import {Grid} from "../Grid";
import {useNavBar} from "../NavBar";
import {Select} from "../Select";
import {Card} from "../TabsRoute/components/Card";
import {Typography} from "../Typography";
import {TSMMonitoringContext, TSMMonitoringProvider} from "./components/TSMMonitoringProvider";
import {DustAlertTrainsTable} from "./components/DustAlertTrains";
import {CallsByState} from "./components/CallsByState";
import {IconCallList} from './components/IconCallList';
import {TSMSvg} from "../TSMAll/components/TSMSvg";
import {ModalTrains, ModalTrainProps} from "../TSMAll/components/ModalTrains";
import {DustAlerts} from "./components/DustAlerts";
import {MineList} from "./components/MineList";
import {columnTitle, columnTitleEnd, rowTitle, selectContainer, allTrains, allTrainsText} from "./styles";
import moment from "moment";
import {useCallLogsByDate, useCallLogsById} from "../../sdk/queries";
//import {ModalNotification, ModalNotificationProps} from "./components/ModalNotification";
import {DetailsIcon} from "../AirQualityMonitoring/components/DataListCard/components/DetailsIcon";
import {tracksideMonitoring} from "../Routes/urls";
import {useHistory} from "react-router-dom";
import {useLocationById} from "../../sdk/queries";

const yearOptions = [{label: "2023", value: "2023"},
		     {label: "2024", value: "2024"},
		     {label: "2025", value: "2025"},
		     {label: "2026", value: "2026"}];

const monthOptions = [
      {label: "January", value: "01"}
    , {label: "February", value: "02"}
    , {label: "March", value: "03"}
    , {label: "April", value: "04"}
    , {label: "May", value: "05"}
    , {label: "June", value: "06"}
    , {label: "July", value: "07"}
    , {label: "August", value: "08"}
    , {label: "September", value: "09"}
    , {label: "October", value: "10"}
    , {label: "November", value: "11"}
    , {label: "December", value: "12"}];


export const TsmTopFive: React.FC = () => {
    const history = useHistory();
    const {userRole} = useAuth();
    const {updatePage} = useNavBar();
    React.useLayoutEffect(() => {
        // Let the navbar know the current page displayed is this one
        updatePage("trackside-monitoring");
    }, []);
    
    const [open, setOpen] = React.useState(false);

    const [openNotification, setOpenNotification] = React.useState(false);

    const [mode, setMode] = React.useState<NonNullable<ModalTrainProps['mode']>>("view");
    const [currId, setCurrId] = React.useState<number | null>(null);

    const findLocationId = () => {
	var path = window.location.pathname;
	var lid_start = path.indexOf('tsm/');
	var lid_end = path.indexOf('/mines');
	return Number(path.substring(lid_start+4,lid_end));
    }
    
    const findYear = (year: string) => {
        return yearOptions.find(x => x.value === year);
    }

    const findMonth = (month: string) => {
        return monthOptions.find(x => x.value === month);
    }

    const fixupUrl = (year: string, month: string) => {
	var path = window.location.pathname;
	var lastSlash = path.lastIndexOf('/');
	window.location.pathname = path.substring(0,lastSlash+1) +
	    year + '-' + month;
    }

    const {data, loading} = useLocationById({
	variables: {
	    id: String(findLocationId()),
	}
    });

    const location = data?.data;
    
    return (
        <TSMMonitoringProvider>
            <TSMMonitoringContext.Consumer>
            {({notifyCallLogsChange, selectedYear, setSelectedYear, selectedMonth, setSelectedMonth}) => (
                <React.Fragment>
                    <Typography leftIcon={<TSMSvg/>} variant={"h1"}>Norfolk Southern High Dust Alert System for {location?.name}</Typography>
		    <TriGrid>
                    <div css={selectContainer}>
                    <Select value={findYear(selectedYear)} options={yearOptions}
                onChange={value => {
                    if (value) {
                        setSelectedYear(value.value)
			fixupUrl(value.value,selectedMonth)
                    }
                }}
                    />
                    </div>
                    <div css={selectContainer}>
                    <Select value={findMonth(selectedMonth)} options={monthOptions}
                onChange={value => {
                    if (value) {
                        setSelectedMonth(value.value);
			fixupUrl(selectedYear,value.value);
                    }
                }}
                    />
                    </div>
		    <div css={allTrains}><p css={allTrainsText}>All Trains</p> <DetailsIcon onClick={() => history.push(tracksideMonitoring + findLocationId() + "/" + selectedYear + "-" + selectedMonth)}/></div>
		    </TriGrid>
                    <Grid lsize="0.3fr" rsize="0.9fr">
                    <DustAlerts location_id={findLocationId()}
		period_s={selectedYear + "-" + selectedMonth} />
		    <MineList location_id={findLocationId()}
		period_s={selectedYear + "-" + selectedMonth} />
                    </Grid>
                    <ModalTrains
                modalProps={{
                    open,
		    width:750,
                    onClose() {
                        setOpen(false);
                    },
                }}
                mode={mode}
                callLogId={currId}
		locationId={findLocationId()}
                    />


		    
		    <Card>
                    <div css={rowTitle}>
                    <div css={columnTitle}>
                    <Typography variant={"h3"} >All High Dust Alert Trains for period</Typography>
                    </div>
                    
                    </div>
                    <DustAlertTrainsTable onView={(id) => {
                        setCurrId(id);
                        setMode("view");
                        setOpen(true);
                    }} location_id={findLocationId()}
		period_s = {selectedYear + "-" + selectedMonth} />
		    </Card>

		    </React.Fragment>
	    )}
	</TSMMonitoringContext.Consumer>
	    </TSMMonitoringProvider>
    );
};

export default TsmTopFive;
